import Result from "@/components/Result";
import Layout from "@/layout";

const NotFoundPage = () => {
  return (
    <Layout>
      <Result style={{ marginTop: 100 }} type="404" />
    </Layout>
  );
};

export default NotFoundPage;
